<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="12" md="12">
                <v-card :elevation="1">
                    <v-card-text class="py-1">
                        <v-row dense>
                            <v-col cols="12" md="2">
                                <v-select
                                    v-model="filterBy"
                                    :items="['All', 'Department', 'Employee']"
                                    label="Filter By"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-1 custom-form"
                                ></v-select>
                            </v-col>

                            <!-- Department Dropdown -->
                            <v-col
                                cols="12"
                                md="2"
                                v-if="filterBy === 'Department'"
                            >
                                <v-combobox
                                    v-model="selectedDepartment"
                                    :items="departments"
                                    label="Select Department"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-1 custom-form"
                                    @focus="getDepartments"
                                ></v-combobox>
                            </v-col>

                            <!-- Employee Dropdown -->
                            <v-col
                                cols="12"
                                md="2"
                                v-if="filterBy === 'Employee'"
                            >
                                <v-combobox
                                    v-model="selectedEmployee"
                                    :items="employees"
                                    label="Select Employee"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-1 custom-form"
                                    @focus="getEmployees"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-combobox
                                    label="Month"
                                    dense
                                    outlined
                                    hide-details
                                    :items="months"
                                    :loading="month_loading"
                                    v-model="selectedMonth"
                                    @focus="getMonths"
                                    item-text="name"
                                    item-value="id"
                                    class="mb-1 custom-form"
                                ></v-combobox>
                            </v-col>

                            <v-col cols="12" md="2" v-if="!selectedMonth">
                                <v-menu
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    v-model="menu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            outlined
                                            hide-details
                                            v-model="date_from"
                                            label="Date From"
                                            v-on="on"
                                            class="custom-form"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date_from"
                                        @input="menu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" md="2" v-if="!selectedMonth">
                                <v-menu
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    v-model="menu2"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            dense
                                            outlined
                                            hide-details
                                            v-model="date_to"
                                            label="Date To"
                                            v-on="on"
                                            class="custom-form"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date_to"
                                        @input="menu2 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" md="2">
                                <v-btn
                                    elevation="1"
                                    small
                                    color="primary"
                                    dark
                                    style="margin-top: -2px"
                                    @click="getRecords"
                                >
                                    Search
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-toolbar dense color="white" :elevation="1" height="30px">
                    <v-toolbar-title class="subtitle-2"
                        >Salary Record</v-toolbar-title
                    >
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row v-if="records.length > 0">
            <v-col cols="12">
                <v-btn
                    color="primary"
                    class="white--text"
                    small
                    dense
                    @click="print"
                >
                    <v-icon left small dense> mdi-printer </v-icon>
                    Print
                </v-btn>
            </v-col>
            <v-col cols="12" md="12" class="py-1" id="reportContent">
                <v-simple-table dense class="record_table">
                    <tr class="record_heading_tr">
                        <th>SL.</th>
                        <th>Entry Date</th>
                        <th>Month</th>
                        <th>Date From</th>
                        <th>Date To</th>
                        <th>Total Gross Salary</th>
                        <th>Total PF</th>
                        <th>Total Deduction</th>
                        <th>Total Advance</th>
                        <th>Total Benefit</th>
                        <th>Total Loan Received</th>
                        <th>Total OT</th>
                        <th>Total Employee Due</th>
                        <th>Total Net Payable</th>
                        <th>Approved By</th>
                        <th>Remark</th>
                        <th>Action</th>
                    </tr>
                    <tr v-for="(record, sl) in records" :key="sl">
                        <td>{{ ++sl }}</td>
                        <td>{{ record.entry_date }}</td>
                        <td>{{ record.month_name }}</td>
                        <td>{{ record.date_from }}</td>
                        <td>{{ record.date_to }}</td>
                        <td>{{ record.total_gross_salary }}</td>
                        <td>{{ record.total_pf }}</td>
                        <td>{{ record.total_deduction }}</td>
                        <td>{{ record.total_advance }}</td>
                        <td>{{ record.total_benefit }}</td>
                        <td>{{ record.total_loan_received }}</td>
                        <td>{{ record.total_ot_amount }}</td>
                        <td>{{ record.total_overtake_salary }}</td>
                        <td>{{ record.total_net_payable }}</td>
                        <td>{{ record.approved_by_name }}</td>
                        <td>{{ record.remark }}</td>
                        <td>
                            <v-btn
                                icon
                                x-small
                                color="error"
                                :to="'/salary_sheet/' + record.id"
                            >
                                <v-icon>mdi-printer</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="5" style="text-align: right">Total=</th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_gross_salary;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_pf;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_deduction;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_advance;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_benefit;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_loan_received;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_ot_amount;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_overtake_salary;
                                }, 0)
                            }}
                        </th>
                        <th>
                            {{
                                records.reduce((prev, curr) => {
                                    return prev + +curr.total_net_payable;
                                }, 0)
                            }}
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
  data() {
    return {
      filterBy: 'All',
      selectedDepartment: null,
      selectedEmployee: null,
      departments: [],
      employees: [],
      months: [],
      selectedMonth: null,
      records: [],
      date_from: this.toISOLocal().substr(0, 10),
      date_to: this.toISOLocal().substr(0, 10),
      menu: false,
      menu2: false,
      month_loading: false,
    };
  },
    watch: {
        selectedMonth(month) {
            if (month && month.id) {
            this.date_from = null;
            this.date_to = null;
            } else {
            this.date_from = this.toISOLocal().substr(0, 10);
            this.date_to = this.toISOLocal().substr(0, 10);
            }
        },
    },
  methods: {
    toISOLocal(d = new Date()) {
      const z = n => (`0${n}`).slice(-2);
      return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
    },

    async getMonths() {
      this.month_loading = true;
      this.selectedMonth = null;
      this.months = await this.$store.dispatch("month/getSalaryMonths", {
        apiParams: {},
        options: {
          returnData: true,
        },
      });
      this.month_loading = false;
    },

    async getDepartments() {
      this.departments = await this.$store.dispatch("department/getDepartments", {
        apiParams: {},
        options: { returnData: true },
      });
    },

    async getEmployees() {
      this.employees = await this.$store.dispatch("employee/getEmployees", {
        apiParams: {},
        options: { returnData: true },
      });
    },

    async getRecords() {
        const apiParams = {
            month_id: this.selectedMonth?.id ?? null,
            date_from: this.date_from,
            date_to: this.date_to,
        };

        // Filter অনুযায়ী শর্ত যোগ করো
        if (this.filterBy === 'Department' && this.selectedDepartment?.id) {
            apiParams.department_id = this.selectedDepartment.id;
        }

        if (this.filterBy === 'Employee' && this.selectedEmployee?.id) {
            apiParams.employee_id = this.selectedEmployee.id;
        }

        this.records = await this.$store.dispatch("salary/getSalaries", {
            apiParams,
            options: {
            returnData: true,
            },
        });
    }

  },
  mounted() {
    this.getMonths();
    this.getRecords();
  }
};
</script>


<style scoped>
.record_table {
    margin-bottom: 5px;
}
.record_table table,
.record_table th,
.record_table td {
    border: 1px solid #dee2e6;
    border-collapse: collapse;
    padding: 0 !important;
}
.record_table th,
.record_table td {
    padding: 2px !important;
    font-size: 11px !important;
    text-align: center;
    height: 0 !important;
}
.record_heading_tr {
    background: #4caf7773;
}

#no-background-hover::before {
    background-color: transparent !important;
}

>>> .v-btn--icon.v-size--default {
    height: unset;
    width: unset;
}

>>> .v-btn--icon.v-size--default .v-icon {
    height: unset;
    width: unset;
}
</style>
